import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorHeader: {
		id: 'portal-settings-request-groups.error-header',
		defaultMessage: "We couldn't load your portal groups",
		description: 'Header of error message shown to user when page fails to get the required data',
	},
	errorMessage: {
		id: 'portal-settings-request-groups.error-message',
		defaultMessage: 'Check your network connection and project permissions.',
		description: 'Error message shown to user when page fails to get the required data',
	},
	spotlightTitle: {
		id: 'portal-settings-request-groups.spotlight-title',
		defaultMessage: 'Request types are now hidden by default.',
		description: 'Title of change onboarding information dialog',
	},
	spotlightDescription: {
		id: 'portal-settings-request-groups.spotlight-description',
		defaultMessage: 'To make a request type visible to customers, add it to a portal group.',
		description: 'Description of change onboarding information dialog',
	},
	spotlightLearnMoreLinkText: {
		id: 'portal-settings-request-groups.spotlight-learn-more-link-text',
		defaultMessage: 'Learn more',
		description: 'Text for learn more link',
	},
	spotlightButtonText: {
		id: 'portal-settings-request-groups.spotlight-button-text',
		defaultMessage: 'Ok',
		description: 'Text for footer button',
	},
});
